import { RouteComponentProps } from 'react-router-dom';
import { oc } from 'ts-optchain';
import _ from 'lodash';

import { PropsToPass } from 'routes/business/SearchModalRoute';
import { consumer } from '@tock/coretypes';
import { disableBackgroundScroll, resumeBackgroundScroll } from 'utils/scrollUtils';
import { getNextRelease } from 'utils/businessUtils';
import { offeringsSelector } from 'selectors/calendarSelectors';
import BaseComponent from '@tock/shared/components/BaseComponent';
import ConfirmSelection from 'components/business/search/ConfirmSelection';
import ExperienceModal from 'components/business/ExperienceModal';
import connect, { DefaultConnectProps, StoreType } from '@tock/shared/utils/connect';

type Props = PropsToPass & RouteComponentProps<MatchParams>;

interface ConnectProps extends DefaultConnectProps {
  calendar: StoreType['calendar'];
  lock: StoreType['lock'];
  ui: StoreType['ui'];
  queryParam: StoreType['queryParam'];
  offerings?: consumer.ConsumerOfferings;
}

interface State {
  experienceId?: number;
}

export interface MatchParams {
  experienceId: string;
  ticketTypeAccessToken: string;
}

class ExperienceRoute extends BaseComponent<Props & ConnectProps, State> {
  constructor(props: Props & ConnectProps) {
    super(props);

    const { match } = props;
    let experienceId;

    if (match.params.experienceId) {
      experienceId = _.toNumber(match.params.experienceId);
    }

    this.state = {
      experienceId,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    if (match.params.ticketTypeAccessToken) {
      this.handleLoadExperienceFromAccessTokenSuccess(this.props);
    }
    disableBackgroundScroll(document);
  }

  componentWillUnmount() {
    resumeBackgroundScroll(document);
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props & ConnectProps) {
    const { calendar, match } = this.props;
    const { calendar: nextCalendar } = nextProps;
    if (match.params.ticketTypeAccessToken && !calendar.calendar && nextCalendar.calendar) {
      this.handleLoadExperienceFromAccessTokenSuccess(nextProps);
    }
  }

  handleLoadExperienceFromAccessTokenSuccess(props: Props & ConnectProps) {
    const { match } = this.props;
    const ticketType = _.find(oc(props.calendar).calendar.ticketType(), (ticketType) => {
      return ticketType.privateAccessToken === match.params.ticketTypeAccessToken;
    });
    if (ticketType) {
      this.setState({
        experienceId: ticketType.id as number,
      });
    }
  }

  render() {
    const {
      actions,
      app,
      app: { config, jwtToken, settings },
      calendar,
      offerings,
      getUrl,
      isSearching,
      isWidget,
      lock,
      match,
      queryParam,
      onClose,
      onSearch,
      onSelectTime,
      ui,
    } = this.props;
    const business = config?.business;

    const { experienceId } = this.state;

    const isAuthenticated = !!jwtToken;
    const nextRelease = getNextRelease(app.config);

    return (
      <>
        <ExperienceModal
          business={business as consumer.BusinessConfig}
          calendar={calendar}
          offerings={offerings}
          experienceId={experienceId}
          getUrlPostfix={getUrl}
          isAuthenticated={isAuthenticated}
          isPrivateOffering={!!match.params.ticketTypeAccessToken}
          isSearching={isSearching}
          isWidget={isWidget}
          isRoute={true}
          isOpen={true}
          lock={lock}
          nextRelease={nextRelease ?? undefined}
          onClose={onClose}
          onSearch={onSearch}
          onSelectTime={onSelectTime}
          onShowError={actions.toast.showError}
        />
        <ConfirmSelection
          app={app}
          business={business as consumer.BusinessConfig}
          explorePath={settings?.EXPLORE_PATH}
          lock={lock}
          queryParam={queryParam}
          lockActions={actions.lock}
          selectionActions={actions.selection}
          setConfirmSelectionDialogVisible={actions.ui.setConfirmSelectionDialogVisible}
          showConfirmSelectionDialog={ui.showConfirmSelectionDialog}
        />
      </>
    );
  }
}

const mapStateToProps = (state: StoreType) => ({
  calendar: state.calendar,
  ui: state.ui,
  lock: state.lock,
  queryParam: state.queryParam,
  offerings: offeringsSelector(state),
});

export default connect<Props, ConnectProps>(ExperienceRoute, mapStateToProps);
